import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useActivity } from '../context/ActivityContext';
import { useCertificateDB } from '../context/CertificateContext';
import { useVerifiedDB } from '../context/VerifiedDBContext';
import { useDatabase } from '../context/DatabaseContext';
import { testGoogleVisionAPI } from '../services/googleVisionOCR';
import { processCertificateFile } from '../services/certificatePipeline';
// Supabase bootstrap removed per user request

const AdminDashboard = () => {
  const { activities, stats } = useActivity();
  const { certificates } = useCertificateDB();
  const { records } = useVerifiedDB();
  const { getInstitutions, resetDatabase } = useDatabase();
  const [activeTab, setActiveTab] = useState('overview');
  const [apiTestResult, setApiTestResult] = useState(null);
  const [testingAPI, setTestingAPI] = useState(false);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  // DB bootstrap UI removed per user request

  const handleLogout = () => {
    console.log('🚪 Logging out');
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    window.location.href = '/login';
  };

    const testVisionAPI = async () => {
    setTestingAPI(true);
    try {
      const result = await testGoogleVisionAPI();
      setApiTestResult(result);
    } catch (error) {
      setApiTestResult({
        success: false,
        error: error.message
      });
    }
    setTestingAPI(false);
  };

  // DB bootstrap handlers removed per user request

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Wave Background */}
      <div className="page-wave-background">
        <img src="/hero-wave.svg" alt="" className="wave-image" />
      </div>
      {/* Enhanced Header */}
      <header className="bg-white shadow-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
                <p className="text-sm text-gray-600 mt-1">Certificate Management System</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              {/* Quick Action Buttons */}
              <div className="flex items-center space-x-4">
                <Link 
                  to="/upload" 
                  className="inline-flex items-center text-sm font-semibold btn-get-started"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                  Upload Certificate
                </Link>
                <Link 
                  to="/check" 
                  className="inline-flex items-center text-sm font-semibold btn-explore"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Verify Certificate
                </Link>
              </div>

              {/* Navigation Menu */}
              <div className="flex items-center space-x-1 border-l border-gray-200 pl-3">
                <Link 
                  to="/" 
                  className="flex items-center px-3 py-2 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Home
                </Link>
                <Link 
                  to="/database" 
                  className="flex items-center px-3 py-2 text-sm font-medium text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
                  </svg>
                  Database
                </Link>
                <button
                  onClick={handleLogout}
                  className="flex items-center px-3 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Quick Actions Bar */}
        <div className="mb-8 bg-white rounded-xl shadow-lg border border-gray-100 p-6">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-1">Quick Actions</h2>
              <p className="text-sm text-gray-600">Manage certificates and system operations</p>
            </div>
            <div className="flex items-center space-x-3">
              <button 
                onClick={() => window.location.reload()}
                className="inline-flex items-center px-4 py-2 text-xs font-semibold rounded-full border border-blue-200 text-blue-600 bg-white hover:bg-blue-50 hover:shadow-sm transition-all"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Refresh Data
              </button>
              <label className="inline-flex items-center px-4 py-2 bg-indigo-50 text-indigo-600 text-sm font-medium rounded-lg hover:bg-indigo-100 transition-colors border border-indigo-200 cursor-pointer">
              
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Bulk Upload
                <input type="file" className="hidden" multiple accept="image/*,.pdf" onChange={async (e) => {
                  const files = Array.from(e.target.files || []);
                  if (files.length === 0) return;
                  setBulkProcessing(true);
                  setBulkResult(null);
                  try {
                    const results = [];
                    for (const f of files) {
                      try {
                        const r = await processCertificateFile({ file: f, institution: getInstitutions()[0]?.id || 'default' });
                        results.push({ ok: true, file: f.name, cid: r.uploadResult?.IpfsHash, hash: r.fileHash, name: r.ocrData?.studentName || '' });
                      } catch (err) {
                        results.push({ ok: false, file: f.name, error: err?.message || String(err) });
                      }
                    }
                    setBulkResult(results);
                  } finally {
                    setBulkProcessing(false);
                  }
                }} />
              </label>
              <button 
                onClick={() => {
                  const data = {
                    activities: activities.slice(0, 10),
                    certificates: certificates.slice(0, 10),
                    records: records.slice(0, 10),
                    stats: stats
                  };
                  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `admin-data-${new Date().toISOString().split('T')[0]}.json`;
                  a.click();
                  URL.revokeObjectURL(url);
                }}
                className="inline-flex items-center px-4 py-2 text-xs font-semibold rounded-full border border-green-200 text-green-600 bg-white hover:bg-green-50 hover:shadow-sm transition-all"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Export Data
              </button>
              <button 
                onClick={() => {
                  if (window.confirm('Are you sure you want to clear all activity logs? This action cannot be undone.')) {
                    localStorage.removeItem('ac_activities_v1');
                    window.location.reload();
                  }
                }}
                className="inline-flex items-center px-4 py-2 text-xs font-semibold rounded-full border border-red-200 text-red-600 bg-white hover:bg-red-50 hover:shadow-sm transition-all"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Clear Logs
              </button>
              <button 
                onClick={() => {
                  if (window.confirm('Reset database to show all institutions? This will reload the page.')) {
                    resetDatabase();
                    window.location.reload();
                  }
                }}
                className="inline-flex items-center px-4 py-2 text-xs font-semibold rounded-full border border-orange-200 text-orange-600 bg-white hover:bg-orange-50 hover:shadow-sm transition-all"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
                </svg>
                Reset DB ({getInstitutions().length} institutions)
            </button>
            
          </div>
        </div>
      </div>

        {/* Enhanced Summary Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatCard 
            title="Total Activities" 
            value={stats.summary.total} 
            icon="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            color="blue"
            trend="+12%"
          />
          <StatCard 
            title="Uploads" 
            value={stats.summary.uploads} 
            icon="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            color="green"
            trend="+8%"
          />
          <StatCard 
            title="Verifications" 
            value={stats.summary.verifications} 
            icon="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            color="purple"
            trend="+15%"
          />
          <StatCard 
            title="Anomalies" 
            value={stats.summary.anomalies} 
            icon="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            color="red"
            trend="-3%"
          />
        </div>

        {/* API Status Test Section */}
        <div className="mt-8 bg-white rounded-xl shadow-lg border border-gray-100">
          <div className="p-6 border-b border-gray-100 text-center">
            <h2 className="text-xl font-semibold text-gray-900">🔧 API Status & Testing</h2>
            <p className="text-gray-600 mt-1">Verify that Google Vision and related services are healthy.</p>
          </div>
          <div className="p-6">
            <div className="max-w-xl mx-auto text-center">
            <button
              onClick={testVisionAPI}
              disabled={testingAPI}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                testingAPI 
                  ? 'bg-gray-400 cursor-not-allowed text-white' 
                  : 'bg-blue-500 hover:bg-blue-600 text-white shadow-md hover:shadow-lg transform hover:-translate-y-0.5'
              }`}
            >
              {testingAPI ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Testing Google Vision API...
                </>
              ) : (
                '🧪 Test Google Vision API'
              )}
            </button>

            {apiTestResult && (
              <div className={`mt-6 p-4 rounded-lg border-l-4 text-left md:text-center ${
                apiTestResult.status === 'success' 
                  ? 'bg-green-50 border-green-400 text-green-800' 
                  : 'bg-red-50 border-red-400 text-red-800'
              }`}>
                <h4 className="font-semibold text-lg mb-1">
                  {typeof apiTestResult.message === 'object' 
                    ? 'API test completed'
                    : apiTestResult.message}
                </h4>
                {apiTestResult.apiKey && (
                  <p className="text-sm mb-2">🔑 API Key: <code className="bg-gray-100 px-2 py-1 rounded text-xs">{apiTestResult.apiKey}</code></p>
                )}
                {apiTestResult.error && (
                  <p className="text-sm mb-2">❌ Error: <code className="bg-gray-100 px-2 py-1 rounded text-xs">{typeof apiTestResult.error === 'object' ? JSON.stringify(apiTestResult.error) : apiTestResult.error}</code></p>
                )}
                {apiTestResult.statusCode && (
                  <p className="text-sm mb-2">📊 Status Code: {apiTestResult.statusCode}</p>
                )}
                {apiTestResult.solution && (
                  <div className="mt-3 p-3 bg-blue-50 rounded border-l-4 border-blue-400">
                    <p className="text-sm font-medium text-blue-800">💡 Solution: {typeof apiTestResult.solution === 'object' ? JSON.stringify(apiTestResult.solution) : apiTestResult.solution}</p>
                  </div>
                )}
              </div>
            )}
            </div>
          </div>
        </div>

        {/* Bulk Upload Results */}
        {bulkProcessing && (
          <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded">Processing files...</div>
        )}
        {bulkResult && (
          <div className="mt-4 bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-semibold text-gray-900">Bulk Upload Summary</h2>
            </div>
            <div className="p-6">
              <div className="space-y-2">
                {bulkResult.map((r, idx) => (
                  <div key={idx} className={`p-3 rounded border ${r.ok ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
                    <div className="flex items-center justify-between">
                      <div className="text-sm font-medium text-gray-900">{r.file}</div>
                      <div className="text-sm">{r.ok ? '✅ Success' : '❌ Failed'}</div>
                    </div>
                    {r.ok ? (
                      <div className="text-xs text-gray-700 mt-1">
                        <div>Hash: <span className="font-mono break-all">{r.hash}</span></div>
                        <div>CID: <span className="font-mono break-all">{r.cid}</span></div>
                        {r.name && <div>Detected Name: {r.name}</div>}
                      </div>
                    ) : (
                      <div className="text-xs text-red-700 mt-1">{r.error}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
          {/* Enhanced Activity Feed */}
          <section className="lg:col-span-2 bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Recent Activity</h2>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-sm text-gray-500">Live</span>
                </div>
              </div>
            </div>
            <div className="p-6">
            <div className="space-y-4 max-h-[500px] overflow-y-auto">
              {activities.slice(0, 50).map(a => (
                  <ActivityItem key={a.id} activity={a} />
                ))}
                {activities.length === 0 && (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                    </div>
                    <p className="text-gray-500">No activities yet</p>
                    <p className="text-sm text-gray-400 mt-1">Upload or verify certificates to see data here</p>
                  </div>
                    )}
                  </div>
            </div>
          </section>

          {/* Enhanced Analytics by Institution */}
          <section className="bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-xl font-semibold text-gray-900">By Institution</h2>
              <p className="text-sm text-gray-500 mt-1">Activity breakdown by institution</p>
            </div>
            <div className="p-6">
              <div className="space-y-4 max-h-[500px] overflow-y-auto">
                {Object.entries(stats.perInstitution).map(([inst, v]) => {
                  const institutionData = getInstitutions().find(i => i.name === inst);
                  return (
                    <div key={inst} className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                          <p className="font-semibold text-gray-900">{inst}</p>
                          {institutionData && (
                            <span className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-full">
                              {institutionData.classification}
                            </span>
                          )}
                        </div>
                        {institutionData && (
                          <p className="text-xs text-gray-500 mb-2">{institutionData.category} • {institutionData.location}</p>
                        )}
                        <div className="flex items-center space-x-4 text-sm">
                          <div className="flex items-center">
                            <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Uploads: <span className="font-medium text-green-600">{v.uploads}</span></span>
                          </div>
                          <div className="flex items-center">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Verifications: <span className="font-medium text-blue-600">{v.verifications}</span></span>
                          </div>
                          <div className="flex items-center">
                            <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Anomalies: <span className="font-medium text-red-600">{v.anomalies}</span></span>
                          </div>
                        </div>
                  </div>
                </div>
                  );
                })}
                {Object.keys(stats.perInstitution).length === 0 && (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <p className="text-gray-500">No institution data yet</p>
                    <p className="text-sm text-gray-400 mt-1">Data will appear as institutions upload certificates</p>
                  </div>
                )}
                </div>
            </div>
          </section>
        </div>

        {/* Enhanced Data Tables */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
          <section className="bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">Certificates</h2>
                  <p className="text-sm text-gray-500 mt-1">Recently uploaded certificates</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">{certificates.length} total</span>
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                </div>
              </div>
            </div>
            <div className="p-6">
            <div className="max-h-[400px] overflow-y-auto">
                {certificates.length > 0 ? (
                  <div className="space-y-3">
                    {certificates.slice().reverse().slice(0, 10).map((c, idx) => (
                      <div key={idx} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                        <div className="flex-1">
                          <div className="flex items-center mb-2">
                            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                              <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{c.file_name}</p>
                              <p className="text-sm text-gray-600">{c.institution}</p>
                            </div>
                          </div>
                          <div className="ml-11 space-y-1">
                            <p className="text-xs text-gray-500 font-mono break-all">Hash: {c.file_hash}</p>
                            <p className="text-xs text-gray-500 font-mono break-all">CID: {c.cid}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <p className="text-gray-500">No certificates uploaded yet</p>
                    <p className="text-sm text-gray-400 mt-1">Upload certificates to see them here</p>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">Verified Records</h2>
                  <p className="text-sm text-gray-500 mt-1">Student verification records</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">{records.length} total</span>
                  <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                </div>
              </div>
            </div>
            <div className="p-6">
            <div className="max-h-[400px] overflow-y-auto">
                {records.length > 0 ? (
                  <div className="space-y-3">
                    {records.slice().reverse().slice(0, 10).map((r) => (
                      <div key={r.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                        <div className="flex-1">
                          <div className="flex items-center mb-2">
                            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                              <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{r.student_name}</p>
                              <p className="text-sm text-gray-600">{r.institution}</p>
                            </div>
                          </div>
                          <div className="ml-11">
                            <p className="text-xs text-gray-500">ID: {r.roll_number || r.certificate_id}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="text-gray-500">No verified records yet</p>
                    <p className="text-sm text-gray-400 mt-1">Import data to populate this table</p>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

const ActivityItem = ({ activity }) => {
  const getActionIcon = (action) => {
    switch (action.toLowerCase()) {
      case 'upload':
        return 'M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12';
      case 'verify':
        return 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z';
      case 'check':
        return 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z';
      default:
        return 'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2';
    }
  };

  const getActionColor = (action) => {
    switch (action.toLowerCase()) {
      case 'upload':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'verify':
        return 'text-blue-600 bg-blue-50 border-blue-200';
      case 'check':
        return 'text-purple-600 bg-purple-50 border-purple-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const hasFlags = activity.flags && activity.flags.length > 0;

  return (
    <div className={`border rounded-lg p-4 transition-all duration-200 hover:shadow-md ${hasFlags ? 'border-red-200 bg-red-50' : 'border-gray-200 bg-white'}`}>
      <div className="flex items-start space-x-3">
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${getActionColor(activity.action)}`}>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getActionIcon(activity.action)} />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-gray-900 capitalize">{activity.action}</span>
            <span className="text-xs text-gray-500">{new Date(activity.ts).toLocaleString()}</span>
          </div>
          <div className="space-y-1 text-sm">
            {activity.institution && (
              <div className="flex items-center">
                <span className="text-gray-500 mr-2">🏛️</span>
                <span className="text-gray-700">{activity.institution}</span>
              </div>
            )}
            {activity.fileHash && (
              <div className="flex items-center">
                <span className="text-gray-500 mr-2">🔗</span>
                <span className="text-gray-600 font-mono text-xs break-all">{activity.fileHash}</span>
              </div>
            )}
            {activity.cid && (
              <div className="flex items-center">
                <span className="text-gray-500 mr-2">📄</span>
                <span className="text-gray-600 font-mono text-xs break-all">{activity.cid}</span>
              </div>
            )}
            {hasFlags && (
              <div className="flex items-center">
                <span className="text-red-500 mr-2">⚠️</span>
                <span className="text-red-600 font-medium">Flags: {activity.flags.join(', ')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ title, value, icon, color, trend }) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      text: 'text-blue-600',
      border: 'border-blue-200'
    },
    green: {
      bg: 'bg-green-50',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      text: 'text-green-600',
      border: 'border-green-200'
    },
    purple: {
      bg: 'bg-purple-50',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      text: 'text-purple-600',
      border: 'border-purple-200'
    },
    red: {
      bg: 'bg-red-50',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      text: 'text-red-600',
      border: 'border-red-200'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;

  return (
    <div className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 ${colors.border} p-6 group hover:scale-105`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mb-2">{value}</p>
          <div className="flex items-center">
            <span className={`text-sm font-medium ${colors.text}`}>{trend}</span>
            <span className="text-xs text-gray-500 ml-1">vs last month</span>
          </div>
        </div>
        <div className={`flex items-center justify-center w-12 h-12 ${colors.iconBg} rounded-lg group-hover:scale-110 transition-transform duration-300`}>
          <svg className={`w-6 h-6 ${colors.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
          </svg>
        </div>
      </div>
  </div>
);
};

export default AdminDashboard;
